import { SEARCH_STARTED } from '../../utils/actionTypes';
import { fetchRepresentatives } from '../representatives/fetchRepresentatives';

/**
 * @param {{address: string, lat: number, long: number, name: string, page: number, per_page: number, sort: string}}
 */

export const searchWithInput = ({
  address,
  lat,
  long,
  name,
  page,
  perPage,
  sort,
  type,
  distance,
  organization,
}) => {
  return dispatch => {
    dispatch({
      type: SEARCH_STARTED,
      payload: {
        currentPage: page,
        searchWithInputInProgress: true,
      },
    });

    fetchRepresentatives(
      address,
      lat,
      long,
      name,
      page,
      perPage,
      sort,
      type,
      distance,
      organization,
      dispatch,
    );
  };
};
